/* eslint-disable @typescript-eslint/no-empty-function */
import { root, ArrayMinOne } from '@estee/elc-universal-utils';

type TranslationsValuesTypes = string | { [key: string]: ITranslations };
export interface ITranslations {
    [key: string]: TranslationsValuesTypes;
}

export interface IConfig {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

export interface IComponentRenderer {
    preloader: {
        preload(): Promise<void>;
        getPreloadedTranslations(fields?: string[]): ITranslations | null;
        getPreloadedConfigs(fields?: string[]): IConfig | null;
    };
}

async function preloadComponentRenderer() {
    const compRenderer = (root.ComponentRenderer as unknown) as IComponentRenderer;
    // App could not be using component renderer
    const preloader = compRenderer ? compRenderer.preloader : null;

    if (preloader && preloader.preload) {
        await preloader.preload();
    }

    return preloader;
}

export async function requestTranslations(fields: ArrayMinOne<string>) {
    const preloader = await preloadComponentRenderer();

    if (preloader) {
        return preloader.getPreloadedTranslations(fields);
    }
    const { GlobalServiceBus, ServiceBusTopics } = root;
    const res = await GlobalServiceBus.query(ServiceBusTopics.queries.GET_TRANSLATIONS, fields);

    return res;
}

export async function requestConfigs(fields: ArrayMinOne<string>) {
    const preloader = await preloadComponentRenderer();

    if (preloader) {
        return preloader.getPreloadedConfigs(fields);
    }
    const { GlobalServiceBus, ServiceBusTopics } = root;
    const res = await GlobalServiceBus.query(ServiceBusTopics.queries.GET_CONFIG, fields);

    return res;
}

export function getRootMethods() {
    const {
        addConfigs = (_: string[]) => {},
        getPreloadedConfigs = (_: string[]) => null,
        registerConfigFieldsToPreload = (_: string[]) => {},
        addTranslations = (_: string[]) => {},
        getPreloadedTranslations = (_: string[]) => null,
        registerTranslationFieldsToPreload = (_: string[]) => {}
    } = root;

    return {
        addConfigs,
        getConfigs: getPreloadedConfigs,
        registerConfigFields: registerConfigFieldsToPreload,
        addTranslations,
        getTranslations: getPreloadedTranslations,
        registerTranslationFields: registerTranslationFieldsToPreload
    };
}

export type MergeMethod<T, P> = (s: T, p: P) => T extends P ? T : P;

export const shallowMerge: MergeMethod<object, object> = (stateConfig, propsConfig) => {
    return {
        ...stateConfig,
        ...propsConfig
    };
};
